module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "chapter-1-processes-and-procedures"
    }
  }, [_c('h1', [_vm._v("Chapter 1 "), _c('br'), _vm._v("Processes and Procedures")]), _vm._v(" "), _c('p', [_vm._v("Business process owners, business process managers and the business staff who execute the processes should know the processes better than anyone else. Process improvements should be controlled through use of a Process Improvement Register.")]), _vm._v(" "), _c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "what-is-a-process"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "padding-top": "30px",
      "padding-bottom": "10px",
      "text-indent": "0px",
      "font-size": "16px",
      "letter-spacing": "1px"
    }
  }, [_vm._v("\nWhat is a Process?")]), _vm._v(" "), _c('p', [_vm._v("A process is a way of doing a repetitive task or tasks in the same way, each and every time the task or tasks are required to be completed.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "contents-of-the-process-document"
    }
  }, [_c('h2', [_vm._v("Contents of the Process Document")]), _vm._v(" "), _c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "process-name"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "padding-top": "30px",
      "padding-bottom": "10px",
      "text-indent": "0px",
      "font-size": "16px",
      "letter-spacing": "1px"
    }
  }, [_vm._v("\nProcess Name")]), _vm._v(" "), _c('p', [_vm._v("Each process should have a name. The business should develop naming standards for the processes which may or may not include a department name. The name should be meaningful so that people have an understanding of the purpose of these processes.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "department"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "padding-top": "30px",
      "padding-bottom": "10px",
      "text-indent": "0px",
      "font-size": "16px",
      "letter-spacing": "1px"
    }
  }, [_vm._v("\nDepartment")]), _vm._v(" "), _c('p', [_vm._v("Entering the department name will allow someone unfamiliar with department processes (such as IT Service Management staff) to know which department the process resides in.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "process-priority"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "padding-top": "30px",
      "padding-bottom": "10px",
      "text-indent": "0px",
      "font-size": "16px",
      "letter-spacing": "1px"
    }
  }, [_vm._v("\nProcess Priority")]), _vm._v(" "), _c('p', [_vm._v("All processes in the organisation should be given a priority in regard to Business Continuity as it will provide an ordered list for the restoration of processes, should some event or disaster happen. The priority will not be immediately known as this will come from carrying out a Business Impact Assessment (BIA) of the process. Business Impact Assessment is covered in Chapter 3.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "process-owner"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "padding-top": "30px",
      "padding-bottom": "10px",
      "text-indent": "0px",
      "font-size": "16px",
      "letter-spacing": "1px"
    }
  }, [_vm._v("\nProcess Owner")]), _vm._v(" "), _c('p', [_vm._v("The process owner is generally regarded as accountable for the process. Additionally, the process owner will be heavily involved with the creation, design and modifications to the process. Many organisations will have the departmental manager as the process owner.")]), _vm._v(" "), _c('p', [_vm._v("Some organisations will appoint departmental managers due to their people management skills rather than their knowledge of the processes in the department. In these organisations, the process managers should also be the process owners.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "process-manager"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "padding-top": "30px",
      "padding-bottom": "10px",
      "text-indent": "0px",
      "font-size": "16px",
      "letter-spacing": "1px"
    }
  }, [_vm._v("\nProcess Manager")]), _vm._v(" "), _c('p', [_vm._v("The process manager manages the process on a day-to-day basis and is responsible for ensuring that the process is carried out as and when required. The process manager is not necessarily the person or persons who perform the process.")]), _vm._v(" "), _c('p', [_vm._v("In small organisations, the process owner, process manager and the person who executes the process may all be the same person.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "last-review-date"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "padding-top": "30px",
      "padding-bottom": "10px",
      "text-indent": "0px",
      "font-size": "16px",
      "letter-spacing": "1px"
    }
  }, [_vm._v("\nLast Review Date")]), _vm._v(" "), _c('p', [_vm._v("To ensure that processes are still relevant and that the process documentation is up to date, each process should be reviewed on a regular basis.")]), _vm._v(" "), _c('p', [_vm._v("Updates to the process will come through by using a Process Improvement Register that will be implemented through Business Change Management. Note that not all updates to a process are going to be IT updates and as the process is owned by the business, process updates have to be under the control of Business Change Management.")]), _vm._v(" "), _c('p', [_vm._v("IT updates that affect the process will be under the control of IT Change Management and if this requires an update to the process documentation, this must be approved by Business Change Management and the process owner.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "reason-for-the-processvalue-to-the-business"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "padding-top": "30px",
      "padding-bottom": "10px",
      "text-indent": "0px",
      "font-size": "16px",
      "letter-spacing": "1px"
    }
  }, [_vm._v("\nReason for The Process—Value to The Business")]), _vm._v(" "), _c('p', [_vm._v("There should always be a reason why the process exists. Each process performed in an organisation should, in some way, help in achieving the strategic objectives of the organisation and should add value, either directly or indirectly.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "business-hours"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "padding-top": "30px",
      "padding-bottom": "10px",
      "text-indent": "0px",
      "font-size": "16px",
      "letter-spacing": "1px"
    }
  }, [_vm._v("\nBusiness Hours")]), _vm._v(" "), _c('p', [_vm._v("This will assist in knowing when the business process is required to be run and when the IT services that support it can be changed.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "process-description"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "padding-top": "30px",
      "padding-bottom": "10px",
      "text-indent": "0px",
      "font-size": "16px",
      "letter-spacing": "1px"
    }
  }, [_vm._v("\nProcess Description")]), _vm._v(" "), _c('p', [_vm._v("The process description provides a detailed description of the process over and above the process name and the reason for the process. It explains the task or tasks that need to be accomplished when the process is being executed.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "process-scope"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "padding-top": "30px",
      "padding-bottom": "10px",
      "text-indent": "0px",
      "font-size": "16px",
      "letter-spacing": "1px"
    }
  }, [_vm._v("\nProcess Scope")]), _vm._v(" "), _c('p', [_vm._v("Each process must have boundaries to ensure that everyone understands what is covered by the process as well as the constraints and limitations of the process.")]), _vm._v(" "), _c('p', [_vm._v("For example, a financial process to pay staff wages may have a scope that excludes new staff if they have not been employed for the whole of the pay cycle, and it may also exclude staff who have resigned. Note that separate processes would be in place for both the exclusions.")]), _vm._v(" "), _c('p', [_vm._v("Certain organisations will leave out the scope from the process document and include it in a Policy document.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "padding-top": "30px",
      "padding-bottom": "10px",
      "text-indent": "0px",
      "font-size": "16px",
      "letter-spacing": "1px"
    }
  }, [_c('strong', [_vm._v("Process Initiator/Trigger")])]), _vm._v(" "), _c('p', [_vm._v("A process has an initiator or trigger which sets the process into motion. This may be output from another process, it may be because a certain event has occurred, or it may be that the process must be run on a regular basis. Some processes will also be triggered by an ad-hoc event, such as a request by a manager.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "process-inputs-and-outputs"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "padding-top": "30px",
      "padding-bottom": "10px",
      "text-indent": "0px",
      "font-size": "16px",
      "letter-spacing": "1px"
    }
  }, [_vm._v("\nProcess Inputs and Outputs")]), _vm._v(" "), _c('p', [_vm._v("Every process will have one or more inputs and one or more outputs. Some of these inputs and outputs will be internal to the department, internal to the organisation or external.")]), _vm._v(" "), _c('p', [_vm._v("No input(s) or output(s) should rely on verbal communication. This will ensure that all input(s) and output(s) are trackable.")]), _vm._v(" "), _c('p', [_vm._v("The dates and times when the input(s) and output(s) are required need to be documented in this section.")]), _vm._v(" "), _c('p', [_vm._v("The format of the input(s) and where they are coming from and how they are accessed should be listed here. For example, are they emailed in a spreadsheet, stored in a known file location, accessed via a website?")]), _vm._v(" "), _c('p', [_vm._v("The format of the output(s) and how they are to be handed over to the person or people that require them should also be listed here.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "process-exceptions"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "padding-top": "30px",
      "padding-bottom": "10px",
      "text-indent": "0px",
      "font-size": "16px",
      "letter-spacing": "1px"
    }
  }, [_vm._v("\nProcess Exceptions")]), _vm._v(" "), _c('p', [_vm._v("Process exceptions are times when you are not able to complete the process as expected. This may be for a number of reasons such as an IT system not being available, the inputs not being ready, or perhaps a natural disaster such as a tsunami or earthquake.")]), _vm._v(" "), _c('p', [_vm._v("During the course of completing the Business Impact Assessment, all the predictable process exceptions will be established and documented. It would be the decision of the organisation to either leave the exceptions in the Business Impact Assessment or to duplicate the exceptions in the process document.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "critical-success-factors-and-key-performance-indicators-csfs-kpis"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "padding-top": "30px",
      "padding-bottom": "10px",
      "text-indent": "0px",
      "font-size": "16px",
      "letter-spacing": "1px"
    }
  }, [_vm._v("\nCritical Success Factors and Key Performance Indicators (CSFs & KPIs)")]), _vm._v(" "), _c('p', [_vm._v("Critical Success Factors (CSFs) and Key Performance Indicators (KPIs) are used widely as metrics to measure processes. Where these are used, each process has a bunch of attached CSFs, and each CSF has a bunch of attached KPIs. For certain organisations, this may be appropriate as this is the style of management that they have adopted, management through measurement. If, on the other hand, an organisation chooses to manage the process, then you only need to ensure that:")]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_vm._v("The process input or inputs are available as and when agreed upon")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("The process output or outputs are delivered as and when agreed upon")])])])]), _vm._v(" "), _c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "roles-and-responsibilities"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "padding-top": "30px",
      "padding-bottom": "10px",
      "text-indent": "0px",
      "font-size": "16px",
      "letter-spacing": "1px"
    }
  }, [_vm._v("\nRoles and Responsibilities")]), _vm._v(" "), _c('p', [_vm._v("Some organisations, particularly larger organisations may want to include a list of roles and responsibilities for the process. The standard way of achieving this is by use of a RACI table or one of the RACI variants that have emerged.")]), _vm._v(" "), _c('p', [_vm._v("The acronym RACI stands for:")]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_vm._v("Responsible – responsible for completing a task or tasks in the process")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Accountable – accountable for the overall completion of the process")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Consulted – consulted and provides input on the process")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Informed – informed in regard to the process")])])]), _vm._v(" "), _c('p', [_vm._v("It is generally agreed that only one person can be accountable for the process, and that would generally be the Process Owner or the Process Manager. However, with critical processes, such as ‘Pay Staff Salaries’, the Board of Directors would be ultimately accountable, therefore a process can have more than one person who is accountable.")]), _vm._v(" "), _c('p', [_vm._v("With the process being documented, the process procedures being documented and with proper communications (chapter 8) in place, there is no need to include a RACI table in the process document. The person or persons executing the process will, as part of the process, consult and inform the people that need to be consulted and informed.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Procedures")])]), _vm._v(" "), _c('p', [_vm._v("The procedures are detailed work instructions listing the steps that are required to execute the process. It is recommended that there is a separate document for the procedures and that they are not included in the process document. Some organisations use one document for the process and the procedures. With one document the process and the procedures can be merged making it more difficult to follow the procedures.")]), _vm._v(" "), _c('div', {
    staticClass: "section level21",
    attrs: {
      "id": "contents-of-the-procedures-document"
    }
  }, [_c('h2', [_vm._v("Contents of the Procedures"), _c('br'), _vm._v(" Document")])])]), _vm._v(" "), _c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "procedure-name"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "padding-top": "30px",
      "padding-bottom": "10px",
      "text-indent": "0px",
      "font-size": "16px",
      "letter-spacing": "1px"
    }
  }, [_vm._v("\nProcedure Name")]), _vm._v(" "), _c('p', [_vm._v("The procedures document should have a name and it is recommended that it be the same as the process name with ‘- Procedures’ appended to it.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "department-1"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "padding-top": "30px",
      "padding-bottom": "10px",
      "text-indent": "0px",
      "font-size": "16px",
      "letter-spacing": "1px"
    }
  }, [_vm._v("\nDepartment")]), _vm._v(" "), _c('p', [_vm._v("Just like the process, the procedures should also include the name of the department.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "procedure-owner"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "padding-top": "30px",
      "padding-bottom": "10px",
      "text-indent": "0px",
      "font-size": "16px",
      "letter-spacing": "1px"
    }
  }, [_vm._v("\nProcedure Owner")]), _vm._v(" "), _c('p', [_vm._v("The procedures document should be owned by the process owner.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "last-review-date-1"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "padding-top": "30px",
      "padding-bottom": "10px",
      "text-indent": "0px",
      "font-size": "16px",
      "letter-spacing": "1px"
    }
  }, [_vm._v("\nLast Review Date")]), _vm._v(" "), _c('p', [_vm._v("Just like the process, the procedures will also require to be reviewed on a regular basis. Additionally, the procedures will also have to be reviewed when the process is modified.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "work-instructionsexecution-steps"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "padding-top": "30px",
      "padding-bottom": "10px",
      "text-indent": "0px",
      "font-size": "16px",
      "letter-spacing": "1px"
    }
  }, [_vm._v("\nWork Instructions/Execution Steps")]), _vm._v(" "), _c('p', [_vm._v("All work instructions or steps to execute the process should begin with the validation of the input or inputs. Each step should be numbered, for example 1, 2, 3. This will aid in troubleshooting the procedures if issues occur.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "exceptions"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "padding-top": "30px",
      "padding-bottom": "10px",
      "text-indent": "0px",
      "font-size": "16px",
      "letter-spacing": "1px"
    }
  }, [_vm._v("\nExceptions")]), _vm._v(" "), _c('p', [_vm._v("In the course of completing the Business Impact Assessment, process exceptions may be highlighted. These exceptions will require detailed steps to complete them. Each exception should be named and the steps to carry out the exception should be numbered.")]), _vm._v(" "), _c('p', [_vm._v("If exceptions are necessary, it should be organisation policy that the person carrying out the exceptions inform their line manager.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02984a68","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch008.vue
// module id = 84
// module chunks = 0